import React from 'react';
import VamosMap from '.';

export default {
  title: 'Components/VamosMap',
  component: VamosMap,
  tags: ['autodocs'],
};

const MapInRoutePage = (args) => {
  return <VamosMap {...args} />;
};

const Template = (args) => MapInRoutePage(args);

export const DefaultMap = Template.bind({});
DefaultMap.args = {
  isEnabled: true,
  setIsEnabled: () => {},
  isBoundsChanged: false,
  isButtonClicked: false,
  setButtonClicked: () => {},
  height: '500px',
  width: '100%',
  center: { lat: 36.95, lng: -100.33 },
  zoom: 4,
};
